import { openDB } from 'idb';
function createDb(name) {
    return openDB(name, 5, {
        upgrade(db, oldVersion) {
            if (oldVersion < 1) {
                if (!db.objectStoreNames.contains('budgets')) {
                    db.createObjectStore('budgets', { keyPath: 'id' });
                }
                if (!db.objectStoreNames.contains('meta')) {
                    db.createObjectStore('meta', { keyPath: 'key' });
                }
            }
            if (oldVersion < 2) {
                if (!db.objectStoreNames.contains('outbox')) {
                    const store = db.createObjectStore('outbox', { keyPath: 'opId' });
                    store.createIndex('by-status', 'status');
                }
                if (!db.objectStoreNames.contains('sync_meta')) {
                    db.createObjectStore('sync_meta', { keyPath: 'key' });
                }
            }
            if (oldVersion < 3) {
                if (!db.objectStoreNames.contains('import_rules')) {
                    db.createObjectStore('import_rules', { keyPath: 'id' });
                }
            }
            if (oldVersion < 4) {
                if (!db.objectStoreNames.contains('import_column_mappings')) {
                    db.createObjectStore('import_column_mappings', { keyPath: 'id' });
                }
            }
            if (oldVersion < 5) {
                if (!db.objectStoreNames.contains('import_mode_rules')) {
                    db.createObjectStore('import_mode_rules', { keyPath: 'id' });
                }
            }
        },
    });
}
// --- Legacy DB (shared, pre-auth) ---
const LEGACY_DB_NAME = 'budget-calendar';
let legacyDbPromise = null;
export function getLegacyDb() {
    if (!legacyDbPromise) {
        legacyDbPromise = createDb(LEGACY_DB_NAME);
    }
    return legacyDbPromise;
}
// --- User-scoped DB ---
let userDbPromise = null;
let currentUserId = null;
export function setCurrentUserId(userId) {
    if (userId === currentUserId)
        return;
    userDbPromise = null;
    currentUserId = userId;
}
export function getUserDb() {
    if (!currentUserId) {
        throw new Error('User ID not set. Call setCurrentUserId() before accessing user DB.');
    }
    if (!userDbPromise) {
        userDbPromise = createDb(`budget-calendar-${currentUserId}`);
    }
    return userDbPromise;
}
/** Routes to user-scoped DB if userId is set, otherwise to legacy DB */
export function getDb() {
    if (currentUserId)
        return getUserDb();
    return getLegacyDb();
}
